import React, { useState, useEffect } from "react";
import { useLottie } from "lottie-react"; // Import the hook
import Lottie from "lottie-react";
import { PrismicRichText } from "@prismicio/react";

export const LottieSideSide = (props) => {
  const sc = props.slice.primary;

  let space = sc.spacing;
  if (space === "Both large") space = "gutter";
  else if (space === "Both small") space = "gutter sm";
  else if (space === "Top large") space = "gutter bot";
  else if (space === "Top small") space = "gutter bot sm";
  else if (space === "Bottom large") space = "gutter top";
  else space = "gutter top sm";

  let bg =
    sc.background === "gradient"
      ? "gradient-to-b from-grey-light to-white"
      : sc.background === "grey"
      ? "grey-light"
      : sc.background === "dark grey"
      ? "grey-d"
      : sc.background;

  const lotty1 = JSON.parse(sc.lottie_json_1);
  const lotty2 = JSON.parse(sc.lottie_json_2);

  // Lottie control hook for both animations
  const options = {
    animationData: lotty1,
    loop: false, // Prevent looping
    autoplay: false, // Disable autoplay
  };

  const options2 = {
    animationData: lotty2,
    loop: false,
    autoplay: false,
  };

  // Lottie hooks for both animations
  const { play: playLottie1 } = useLottie(options);
  const { play: playLottie2 } = useLottie(options2);

  // State to track if animation has played
  const [hasPlayed, setHasPlayed] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasPlayed) {
          playLottie1(); // Play Lottie1 animation
          playLottie2(); // Play Lottie2 animation
          setHasPlayed(true); // Prevent looping
          observer.disconnect(); // Stop observing after first play
        }
      },
      { threshold: 0.1 } // Trigger when at least 10% of the element is visible
    );

    const element = document.querySelector("#lottie-container");
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect(); // Cleanup observer
  }, [hasPlayed]);

  const lightBG = ["gradient", "grey", "white"].includes(sc.background) ? sc.background : null;
  const textCheck = lightBG != null ? "text-grey" : "text-white";

  return (
    <section className={"lottie bg-" + bg + " " + " " + space}>
      <div className="wrapper inner">
      <div className={"text-left md:text-center mb-12 " + textCheck}>
      <PrismicRichText field={sc.section_title.richText} />
        <PrismicRichText field={sc.section_content.richText} /></div>
        <div className="flex flex-col md:flex-row justify-between">
          <div className="w-full md:w-1/2" id="lottie-container">
            <div>
              <Lottie
                animationData={lotty1}
                aria-labelledby="use lottie animation"
                loop={false}
                autoPlay={false} // Prevent auto play
              />
            </div>
          </div>
          <div className="w-full md:w-1/2">
            <div>
              <Lottie
                animationData={lotty2}
                aria-labelledby="use lottie animation"
                loop={false}
                autoPlay={false}
              />
            </div>
          </div>
        </div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: sc.custom_html }} />
    </section>
  );
};
